// third-party
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';

// project import
import reducers from './reducers';
import { loadState, getJwt } from './utils/localStorage';
import { authInitialState } from './reducers/autenticacao.reducer';
import rootSagas from './sagas';
import { middleware as routesMiddleware, enhancer as routesEnhancer } from './routes';

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

// Tema do parceiro assado no index.html em build time (ver config/update-index.js).
// Quando presente, prima o slice whitelabel para o primeiro paint ja sair com a
// identidade do parceiro, sem flash do tema Homefin. Builds "main" (homefin.com.br)
// nao tem esse global e caem no fallback Homefin normalmente.
const getPartnerWhitelabelPreloaded = () => {
  if (typeof window === 'undefined') return null;
  const wl = window.__PARTNER_WHITELABEL__;
  if (!wl || typeof wl !== 'object') return null;
  return {
    parceiro: {
      loading: false,
      error: false,
      paleta: wl.paleta && typeof wl.paleta === 'object' ? wl.paleta : {},
      logo: Array.isArray(wl.logo) ? wl.logo : []
    }
  };
};

const getSafePreloadedState = () => {
  const saved = loadState();
  // Strip usuario e auth do localStorage — perfil vem sempre do backend via /auth/me
  const { usuario, auth, ...rest } = saved ?? {};

  const base = { ...rest };
  const whitelabel = getPartnerWhitelabelPreloaded();
  if (whitelabel) {
    base.whitelabel = whitelabel;
  }

  if (getJwt()) {
    return { ...base, auth: { ...authInitialState, isVerifyingSession: true } };
  }
  return Object.keys(base).length ? base : undefined;
};

const sagaMiddleware = createSagaMiddleware();

const initializeStore = () => {
  const store = configureStore({
    reducer: reducers,
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState: getSafePreloadedState() ?? {},
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(routesMiddleware).concat(sagaMiddleware).concat(logger),
    enhancers: (defaultEnhancers) => [routesEnhancer, ...defaultEnhancers()],
  });

  sagaMiddleware.run(rootSagas);
  return store;
}

const store = initializeStore();
const { dispatch } = store;

export { store, dispatch };